import posthog from 'posthog-js'

type LogAttributes = Record<string, string | number | boolean>

const posthogConfigured = Boolean(
  import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN && import.meta.env.VITE_PUBLIC_POSTHOG_HOST
)

export function logPosthogInfo(message: string, attributes: LogAttributes) {
  if (!posthogConfigured) return
  posthog.logger.info(message, attributes)
}
